export const NON_STANDARD_RISK = 'Non standard risk';
export const TITLE = 'Non Standard Risk Form';
export const TERMS = 'TERMS';
export const CHOOSE_ALL_TEXT = 'CHOOSE ALL THAT APPLY';
export const NON_STANDARD_RISK_DESCRIPTION =
  'Non-standard risk are uncommon and will mainly arise in three-year-plus contracts and in contracts with non-standard pricing. Please refer to the non-standard toolkit site, which lists many of these risks as previously encountered in Chemicals contracts. Any non-standard risks in contracts require the inclusion of Legal in the initial request for mandate approval.';
